export const CREDIT_STATUSES = {
  PENDING: 'Pending',
  COMPLETED: 'Completed',
};

export const PUBLISHED_STATUSES = {
  PUBLISHED: 'Published',
  IN_PROGRESS: 'In Progress'
};
